module.exports = __webpack_public_path__ + "img/warehouse.386ae960.jpg";